import { render, staticRenderFns } from "./DatosProspectoSocioExtranjero.vue?vue&type=template&id=4f191a50"
import script from "./DatosProspectoSocioExtranjero.vue?vue&type=script&lang=js"
export * from "./DatosProspectoSocioExtranjero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports